import MicroModal from 'micromodal';

let savedScrollY = 0;
let isLocked = false;

const lockScroll = () => {
    if (isLocked) {
        return;
    }
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${savedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    isLocked = true;
};

const unlockScroll = () => {
    if (!isLocked) {
        return;
    }
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    document.body.classList.remove('modal-open', 'is-locked');
    const prevBehavior = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(0, savedScrollY);
    document.documentElement.style.scrollBehavior = prevBehavior;
    isLocked = false;
};

export default class Modal {
    static init(): void {
        MicroModal.init({
            openTrigger: 'data-micromodal-trigger',
            closeTrigger: 'data-micromodal-close',
            disableScroll: false,
            disableFocus: false,
            awaitOpenAnimation: false,
            awaitCloseAnimation: false,
            onShow: () => {
                lockScroll();
            },
            onClose: () => {
                unlockScroll();
            },
        });
    }
}
